/**
 * Every fixture across every sport.
 *
 * `FixturesTable` already did its searching and paging by calling back into a
 * loader prop, which was a Server Action wrapping `loadFixtures`. The action
 * added nothing but the round trip — the work was always `loadFixtures` — so
 * the SPA passes that function in directly and the action goes away.
 */

import { FixturesTable } from "@/components/fixtures/FixturesTable";
import { PageHead, Problem } from "@/components/kit";
import { loadFixtures } from "@/lib/fixtures/load";
import { loadSportRows } from "@/lib/sportRows";
import { useApi } from "@/spa/useApi";

export function FixturesPage() {
  const { data, loading, error } = useApi(
    () => Promise.all([loadFixtures(), loadSportRows()]),
    [],
    "failed to load fixtures",
  );

  if (error) return <Problem>Could not reach the admin service: {error}</Problem>;

  const heading = (
    <PageHead
      title="Fixtures"
      note={!data && loading ? "Loading…" : "Every fixture across every sport."}
    />
  );
  if (!data) return heading;

  const [page, sports] = data;
  return (
    <>
      {heading}
      <FixturesTable
        page={page}
        sports={sports.map((s) => ({ code: s.code, icon: s.icon }))}
        load={loadFixtures}
      />
    </>
  );
}
